var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b;
import { cx } from '@emotion/css';
import { FontFamily, TitleSize } from './typography.type';
import { cssBaseColor, cssBaseTypo, cssModifier, cssTypoSize } from './css';
var mapping = {
    title: (_a = {},
        _a[TitleSize.xl] = {
            fontSize: 3.6,
            fontSizeMq: 4,
            lineHeight: 4.4
        },
        _a[TitleSize.lg] = {
            fontSize: 2.8,
            fontSizeMq: 3.2,
            lineHeight: 4.2
        },
        _a[TitleSize.md] = { fontSize: 2.6, lineHeight: 4.2 },
        _a[TitleSize.sm] = { fontSize: 2.4, lineHeight: 3.2 },
        _a[TitleSize.xs] = { fontSize: 2.2, lineHeight: 3 },
        _a[TitleSize.xxs] = { fontSize: 2, lineHeight: 2.6 },
        _a[TitleSize.xxxs] = { fontSize: 1.8, lineHeight: 2.3 },
        _a),
    text: (_b = {},
        _b[TitleSize.lg] = { fontSize: 2, lineHeight: 3 },
        _b[TitleSize.md] = { fontSize: 1.8, lineHeight: 2.5 },
        _b[TitleSize.sm] = { fontSize: 1.6, lineHeight: 2.4 },
        _b[TitleSize.xs] = { fontSize: 1.4, lineHeight: 2.1 },
        _b[TitleSize.xxs] = { fontSize: 1.2, lineHeight: 1.5 },
        _b)
};
export var getComponentProps = function (_a) {
    var size = _a.size, _b = _a.isTitle, isTitle = _b === void 0 ? false : _b;
    return function (_a) {
        var color = _a.color, className = _a.className, _b = _a.isCentered, isCentered = _b === void 0 ? false : _b, _c = _a.isBold, isBold = _c === void 0 ? false : _c, _d = _a.fontFamily, fontFamily = _d === void 0 ? FontFamily.SourceSansPro : _d, props = __rest(_a, ["color", "className", "isCentered", "isBold", "fontFamily"]);
        return (__assign({ className: cx(cssBaseColor({ color: color }), cssBaseTypo({ isBold: isBold, fontFamily: fontFamily }), cssTypoSize({ typo: mapping[isTitle ? 'title' : 'text'], size: size }), cssModifier({ isCentered: isCentered }), className) }, props));
    };
};
export var cssProps = {
    link: {
        fontSize: 1.6,
        lineHeight: 2.4,
        desktopFontSize: 1.6,
        desktopLineHeight: 2.4
    },
    label1: {
        fontSize: 1.8,
        lineHeight: 2.6,
        desktopFontSize: 1.8,
        desktopLineHeight: 2.6
    },
    label2: {
        fontSize: 1.4,
        lineHeight: 2.2,
        desktopFontSize: 1.4,
        desktopLineHeight: 2.2
    },
    subtitle1: {
        fontSize: 2.0,
        lineHeight: 2.8,
        desktopFontSize: 2.2,
        desktopLineHeight: 3.0
    },
    body1: {
        fontSize: 1.8,
        lineHeight: 2.6,
        desktopFontSize: 1.8,
        desktopLineHeight: 2.6
    },
    body2: {
        fontSize: 1.6,
        lineHeight: 2.4,
        desktopFontSize: 1.6,
        desktopLineHeight: 2.4
    },
    body3: {
        fontSize: 1.4,
        lineHeight: 2.2,
        desktopFontSize: 1.4,
        desktopLineHeight: 2.2
    },
    body4: {
        fontSize: 1.2,
        lineHeight: 1.6,
        desktopFontSize: 1.2,
        desktopLineHeight: 1.6
    },
    title1: {
        fontSize: 2.6,
        lineHeight: 3.4,
        desktopFontSize: 2.8,
        desktopLineHeight: 3.6
    },
    title2: {
        fontSize: 2.4,
        lineHeight: 3.2,
        desktopFontSize: 2.4,
        desktopLineHeight: 3.2
    },
    title3: {
        fontSize: 2.0,
        lineHeight: 2.8,
        desktopFontSize: 2.0,
        desktopLineHeight: 2.8
    },
    title4: {
        fontSize: 1.8,
        lineHeight: 2.6,
        desktopFontSize: 1.8,
        desktopLineHeight: 2.6
    },
    headline1: {
        fontSize: 3.2,
        lineHeight: 4.0,
        desktopFontSize: 4.0,
        desktopLineHeight: 4.8
    },
    headline2: {
        fontSize: 2.8,
        lineHeight: 3.6,
        desktopFontSize: 3.2,
        desktopLineHeight: 4.0
    },
    headline3: {
        fontSize: 2.8,
        lineHeight: 3.6,
        desktopFontSize: 3.2,
        desktopLineHeight: 4.0
    },
    display1: {
        fontSize: 4.2,
        lineHeight: 5.8,
        desktopFontSize: 5.6,
        desktopLineHeight: 7.2
    },
    display2: {
        fontSize: 3.6,
        lineHeight: 5.2,
        desktopFontSize: 4.8,
        desktopLineHeight: 6.4
    }
};
export var getDefaultComponentFromVariant = function (variant) {
    if (['display1', 'display2'].includes(variant)) {
        return 'h1';
    }
    if (['headline1', 'headline2', 'headline3'].includes(variant)) {
        return 'h2';
    }
    if (['title1', 'title2', 'title3', 'title4'].includes(variant)) {
        return 'h3';
    }
    return 'span';
};
export var getFontFamilyFromVariant = function (variant) { return ['display1', 'display2', 'headline1', 'headline2'].includes(variant)
    ? FontFamily.PublicoHeadlineBold
    : FontFamily.SourceSansPro; };
export var getFontWeight = function (variant, bodyFontWeight) {
    if (variant === 'label2') {
        return '700';
    }
    if (['body1', 'body2', 'body3', 'body4'].includes(variant)) {
        return bodyFontWeight;
    }
    return variant === 'label1'
        ? '400'
        : '600';
};
